import toast from 'react-hot-toast';
import { registerSW } from 'virtual:pwa-register';

export function registerPwa(): void {
  if (import.meta.env.DEV) return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      toast(
        (t) => (
          <span className="flex items-center gap-3">
            <span>Доступно обновление кабинета</span>
            <button
              type="button"
              onClick={() => {
                toast.dismiss(t.id);
                void updateSW(true);
              }}
              className="font-semibold text-orange-600 hover:text-orange-700"
            >
              Обновить
            </button>
          </span>
        ),
        { duration: 10_000, position: 'bottom-right' },
      );
    },
    onOfflineReady() {
      toast.success('Кабинет готов к офлайн-работе', { position: 'bottom-right' });
    },
  });
}
